import axios from 'axios';

//const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5130/';
const BASE_URL = process.env.REACT_APP_API_URL || 'https://sssdkapi.prowesserp.in'; 
console.log("BASE_URL =", BASE_URL);
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
});
console.log("BASE_URL =", BASE_URL);
export default api;   // ← this line must be present